import React, { useState, useContext } from "react";
import { Navigate } from "react-router-dom";
import { Row, Col, Alert, Button, Container, Form } from 'react-bootstrap';
import config from "../etc/config.json";
import devUser from "../etc/DevUser.json";
import { C4FStatusContext, EventContext, UserInformationContext } from "../main/App";
import md5 from 'md5-hash';
import packageJson from '../../package.json';

function Login() {

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [newPassword1, setNewPassword1] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [pwInfo, setPasswordInfo] = useState(null);
  const { setEvents } = useContext(EventContext);
  const { userInformation, setUserInformation } = useContext(UserInformationContext);
  const { setLanguage, raiseError, handleBackendRequest } = useContext(C4FStatusContext);
  const [tab, setTab] = useState('login');

  function handleLoginResponse(userInformation) {
    setUserInformation(userInformation);
    setLanguage(userInformation.language);
    loadEvents();
  }

  function handleLogin() {
    if (userName.length === 0)
      raiseError('Login Failed', 0, 'no user provided');
    else if (password.length === 0)
      raiseError('Login Failed', 0, 'no password provided');
    else
      handleBackendRequest('POST', '/user/' + userName + '/authenticate', {}, {
        encryptedPassword: md5(password),
        version: packageJson.version
      }, handleLoginResponse);
  }

  function handleDevLogin() {
    setUserInformation(devUser);
  }

  function loadEvents() {
    handleBackendRequest('GET', '/generalInformation/event', null, null, setEvents);
  }

  function handlePasswordResetResponse() {
    setPasswordInfo('Password changed. You can now login.');
    setUserName('');
    setEmail('');
    setNewPassword1('');
    setNewPassword2('');
  }

  function handlePasswordReset() {
    if (userName.length === 0)
      raiseError('Password change failed', 0, 'no user provided');
    else if (email.length === 0)
      raiseError('Password change failed', 0, 'no email provided');
    else if (newPassword1.length < 8)
      raiseError('Password change failed', 0, 'password needs to have at least 8 characters');
    else if (newPassword1 !== newPassword2)
      raiseError('Password change failed', 0, "Passwords don't match");
    else
      handleBackendRequest('POST', '/user/' + userName + '/resetPassword', {}, {
        email: email,
        newEncryptedPassword1: md5(newPassword1),
        newEncryptedPassword2: md5(newPassword2)
      }, handlePasswordResetResponse, false, null, false, 'Password change failed');
  }

  if (userInformation !== null) {
    if (userInformation.fairplayCases.some(n => n.status === 'Open') || userInformation.fairplayCases.some(n => n.status === 'Voting'))
      return <Navigate to="/fairplay" />;
    else {
      if (userInformation.notifications.length > 0 && userInformation.notifications.some(n => n.status === 'Unread'))
        return <Navigate to="/messagesUnread" />;
      else
        return <Navigate to="/home" />;
    }
  }

  else if (tab === 'login') {
    return (
      <Container style={{ backgroundColor: 'rgba(222, 233, 244, 1)' }}>
        <Row className="h-50 justify-content-center text-center pt-5 pb-3">
          <Col sm="4" />
          <Col sm="4">
            <Form.Control type="text"
              onChange={(e) => setUserName(e.target.value)}
              onKeyPress={(e) => (e.key === 'Enter') ? handleLogin() : null}
              placeholder="team name"
              value={userName} />
            <br />
            <Form.Control type="password"
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) => (e.key === 'Enter') ? handleLogin() : null}
              placeholder="password"
              value={password} />

            <Button className="mt-3" variant="primary" onClick={handleLogin}>Sign In</Button>
            <br />
            {config.DEV_MODE && config.REST_API.match('localhost') ?
              <Button className="my-3" variant="warning" onClick={handleDevLogin}>Shortcut</Button>
              : null}
            {/* {
              (loginInfo !== null) ?
                <Alert key="alert1" variant={'warning'}>{loginInfo}</Alert>
                :
                null
            } */}
            <br />
            <a href="#" onClick={() => setTab('pwreset')}>I forgot my password.</a>
            <br />
            <br />
            <p>{packageJson.name} {packageJson.version}</p>
          </Col>
          <Col sm="4" />
        </Row>

      </Container>
    );
  }

  else if (tab === 'pwreset') {
    return (
      <Container style={{ backgroundColor: 'rgba(222, 233, 244, 1)' }}>
        <Row className="h-50 justify-content-center text-left pt-5 pb-3">
          <Col sm="4" />
          <Col sm="4">
            <p>
              <b>Forgot your Password?</b><br />
              There are two ways to reset your password:<br />
              <br />
              <b>1) Self-Reset</b> for inactive teams<br />
              <b>2) Admin-Reset</b> for active teams<br />
              <br />
              <u><b>1) Self-Reset</b> for inactive teams</u><br />
              Your team is inactive if<br />
              - your team has <b>no active riders</b>.<br />
              - your team's budget is <b>less than $20,000,000</b>.<br />
              - your last login is <b>more than 90 days</b> ago.<br />
            </p>
            <table className="table table-sm align-middle text-center m-0" style={{ width: 330 }}>
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><b>Team Name</b></td>
                  <td>
                    <Form.Control type="text"
                      onChange={(e) => setUserName(e.target.value)}
                      onKeyPress={(e) => (e.key === 'Enter') ? handlePasswordReset() : null}
                      placeholder="team name"
                      value={userName} />
                  </td>
                </tr>
                <tr>
                  <td><b>E-Mail</b></td>
                  <td>
                    <Form.Control type="text"
                      onChange={(e) => setEmail(e.target.value)}
                      onKeyPress={(e) => (e.key === 'Enter') ? handlePasswordReset() : null}
                      placeholder="email"
                      value={email} />
                  </td>
                </tr>
                <tr>
                  <td><b>New Password</b></td>
                  <td>
                    <Form.Control type="password"
                      onChange={(e) => setNewPassword1(e.target.value)}
                      onKeyPress={(e) => (e.key === 'Enter') ? handlePasswordReset() : null}
                      placeholder="new password"
                      value={newPassword1} />
                  </td>
                </tr>
                <tr>
                  <td><b>Confirm Password</b></td>
                  <td>
                    <Form.Control type="password"
                      onChange={(e) => setNewPassword2(e.target.value)}
                      onKeyPress={(e) => (e.key === 'Enter') ? handlePasswordReset() : null}
                      placeholder="confirm password"
                      value={newPassword2} />
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <Button variant="primary" onClick={handlePasswordReset}>Reset Password</Button>
                  </td>
                </tr>
              </tbody>
            </table>

            <br />
            {
              (pwInfo !== null) ?
                <Alert key="alert1" variant={'warning'}>{pwInfo}</Alert>
                :
                null
            }
            Go back to the <a href="#" onClick={() => setTab('login')}>Login</a>.<br />
            <br />
            <p>
              <u><b>2) Admin-Reset</b> for active teams</u><br />
              <br />
              For security reasons, only the admins can reset passwords of active teams. In the <a href={config.FORUM_BASE_URL} target="_blank" rel="noreferrer">Forum</a>, you can write a private message (pm) to <a href={config.FORUM_BASE_URL + 'memberlist.php?mode=viewprofile&u=956'} target="_blank" rel="noreferrer">Gipfelstuermer</a> or <a href={config.FORUM_BASE_URL + 'memberlist.php?mode=viewprofile&u=101'} target="_blank" rel="noreferrer">Alkworld</a>.
            </p>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </Col>
          <Col sm="4" />
        </Row>
      </Container>
    );
  }

}

export default Login;